export const FEATURE_FLAGS_API_HOST = process.env.NEXT_PUBLIC_FEATURE_FLAGS_API_HOST

export const resolveFeatureFlagsClientKey = (): string | undefined => {
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV

  if (appEnv === 'prod') {
    return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_PROD
  }

  if (appEnv === 'staging') {
    return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_STAGING
  }

  return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_DEV
}

export const isFeatureFlagsConfigured = (): boolean => Boolean(resolveFeatureFlagsClientKey())

export const isProdFeatureFlagsEnv = (): boolean =>
  process.env.APP_ENV === 'prod' || process.env.NEXT_PUBLIC_APP_ENV === 'prod'

export const isFeatureFlagsDevToolsEnabled = (): boolean => !isProdFeatureFlagsEnv()
